module.exports = __webpack_public_path__ + "img/parenting-videos.2fad71d9.svg";